import { gql, useMutation, useQuery } from '@apollo/client';

const mutation = gql`
  mutation CreateUserBorrowerAndLoan($input: OnboardBorrowerInput!) {
    createUserBorrowerAndLoan(onboardBorrowerInput: $input)
  }
`

const ON_BOARD_WITH_NEW_OWNERSHIP = gql`
  mutation CreateLoanWithOwnership($input: CreateLoanWithOwnershipInput!) {
    createLoanWithOwnership(createLoanWithOwnershipInput: $input)
  }
`

const GET_OWNERSHIPS_BY_CREATOR = gql(`
    query GetOwnershipsByCreator($ownerId: String!) {
        GetOwnershipsByCreator(ownerId: $ownerId) {
            _id
            name
            lastname
            phone
            email
            state
            loans {
              _id
            }
        }  
    }
`)

export const useBorrowerOnboarding = () => {
  const [execute, { data, fetching, error }] = useMutation(
    mutation,
    { fetchPolicy: 'no-cache' }
  );

  return {
    execute: (data) => execute({ variables: { input: data }}),
    data,
    fetching,
    error
  };
};

export const useNewOwnershipOnboarding = () => {
  const [execute, { data, fetching, error }] = useMutation(
    ON_BOARD_WITH_NEW_OWNERSHIP,
    { fetchPolicy: 'no-cache' }
  );

  return {
    execute: (data) => execute({ variables: { input: data }}),
    data,
    fetching,
    error
  };
};

export const useGetOwnershipsByCreator = (vars) => {
  const result = useQuery(GET_OWNERSHIPS_BY_CREATOR, {
    variables: { ownerId: vars?.ownerId},
    skip: vars?.skip || !vars?.ownerId,
    ...vars,
  });
  return {
    ...result,
    data: result.data?.GetOwnershipsByCreator,
  };
};
